import { useEffect, useRef, useState } from 'react';
import CopyIcon from '../assets/copy-icon.svg';

interface ChatCopyButtonProps {
  onCopy: () => Promise<void>;
  label: string;
  copiedLabel?: string;
  className?: string;
}

const COPIED_RESET_MS = 2000;

const ChatCopyButton = ({ onCopy, label, copiedLabel = 'Copied', className }: ChatCopyButtonProps) => {
  const [copied, setCopied] = useState(false);
  const resetTimeout = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => () => clearTimeout(resetTimeout.current), []);

  const handleClick = async () => {
    try {
      await onCopy();
    } catch {
      // Clipboard writes reject on denied permissions / insecure contexts; keep the affordance
      // silent rather than surfacing an error or leaving an unhandled rejection.
      return;
    }
    setCopied(true);
    clearTimeout(resetTimeout.current);
    resetTimeout.current = setTimeout(() => setCopied(false), COPIED_RESET_MS);
  };

  return (
    <button type="button" className={`chat-copy-button${className ? ` ${className}` : ''}`} onClick={handleClick}>
      <span
        className="chat-copy-button-icon"
        style={{ maskImage: `url(${CopyIcon})`, WebkitMaskImage: `url(${CopyIcon})` }}
        aria-hidden="true"
      />
      {copied ? copiedLabel : label}
    </button>
  );
};

export default ChatCopyButton;
